import React from 'react';
import PropTypes from 'prop-types';
import {withFormsy} from 'formsy-react';
import {Button} from 'epic-diesel-common';
import FileUpload from 'react-files';
import Message from '../common/Message';

class FileInput extends React.Component {
    static propTypes = {
        isPristine: PropTypes.func,
        showRequired: PropTypes.func,
        setValue: PropTypes.func,
        getValue: PropTypes.func,
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
        value: PropTypes.any,
        required: PropTypes.bool,
        name: PropTypes.string,
        errorClass: PropTypes.string
    };

    onFilesChange = files => {
        this.props.setValue(files[0]);
        const {onChange, name} = this.props;
        if (onChange) {
            onChange(name, files[0]);
        }
        files.splice(0, 1);
    };

    render() {
        const {
            value,
            required,
            disabled,
            getValue,
            isPristine,
            showRequired,
            errorClass
        } = this.props;
        return (
            <div>
                {disabled ? (
                    getValue()
                ) : (
                    <div>
                        <label
                            htmlFor="file"
                            className={!isPristine() && showRequired() ? errorClass : ''}>
                            {required && '*'} <Message code="ui.message.taxInfo.w9.label" />
                        </label>
                        <FileUpload
                            className="files-dropzone"
                            onChange={this.onFilesChange}
                            accepts={['application/pdf']}
                            minFileSize={1}
                            clickable>
                            <Button theme="dark">
                                <Message code="ui.message.taxInfo.w9.uploadBtn" />
                            </Button>
                            &nbsp;&nbsp;{value && <strong>{value.name}</strong>}
                            {value && <span> ( {value.sizeReadable} )</span>}
                        </FileUpload>
                    </div>
                )}
            </div>
        );
    }
}

export default withFormsy(FileInput);
